import { BookmarkFill, SignpostFill, BrushFill, ChatSquareQuoteFill, AwardFill, LightbulbFill } from "react-bootstrap-icons";

export function getNotchTypes () {
    return [
		{ value: "notch", label: "Notch" },
		{ value: "memory", label: "Memory" },
		{ value: "milestone", label: "Milestone" },
		{ value: "thought", label: "Thought" },
		{ value: "achievement", label: "Achievement" },
		{ value: "idea", label: "Idea" },
	]
};

export function getNotchIcon(type, settings = {}) {
    const { color = null, ...restSettings } = settings;

    const props = {
        size: 16,
        className: "ms-auto me-2 flex-shrink-0",
        ...restSettings,
        ...(color && { color }),
    };

    switch (type) {
        case 'notch':
            return <BookmarkFill {...props} />;
        case 'milestone':
            return <SignpostFill {...props} />;
        case 'thought':
            return <BrushFill {...props} />;
        case 'memory':
            return <ChatSquareQuoteFill {...props} />;
        case 'achievement':
            return <AwardFill {...props} />;
        case 'idea':
            return <LightbulbFill {...props} />;
        default:
            return <BookmarkFill {...props} />;
    }
}